import React, {Component} from 'react';
import './css/TestList.css';
import API from "../api/API";
import ScoreUtils from "../utils/ScoreUtils";

class TestList extends Component {
    state = {
        groups: [],
        name: '',
        group: 0,
        duration: 60,
        inProgress: {},
        finished: {},
        scores: {},
        showMembers: {},
        lecturers: [],
        sharedTests: [],
        screen: "list"
    };

    componentWillMount() {
        API.callAPI('groups/')
            .then(response => {
                let groups = [];
                if (!response['error']) {
                    groups = response.splice(0);
                    groups.sort((a, b) => a.name.localeCompare(b.name))
                }
                this.setState({ group: groups[0], groups: groups })
            })
            .then(() => {
                this.loadTests();
                this.loadLecturers();
            });
    }

    componentDidMount() {
        const refreshInterval = setInterval(() => {
            this.loadTests();
        }, 10000);

        this.setState({ refreshInterval: refreshInterval });
    }

    componentWillUnmount() {
        clearInterval(this.state.refreshInterval);
    }

    loadLecturers = () => {
        API.callAPI('lecturers/')
            .then(response => {
                const lecturers = response.sort((a, b) => a.last_name.localeCompare(b.last_name));
                this.setState({ lecturers: lecturers });
            });
    };

    loadTests = () => {
        API.callAPI('tests/')
            .then(response => {
                const grouped_tests = [];
                const groups = [];

                for (const test of response) {
                    const group_id = test.group_id;

                    if (this.props.user && this.props.user.user_type === 'lecturer') {
                        if (test.in_progress) {
                            API.callAPI('tests/run/?id=' + test.test_id)
                                .then(response => {
                                    const inProgress = this.state.inProgress;
                                    inProgress[test.test_id] = response;
                                    this.setState({ inProgress: inProgress });
                                });
                        } else {
                            const inProgress = this.state.inProgress;
                            inProgress[test.test_id] = [];
                            this.setState({ inProgress: inProgress });
                        }

                        API.callAPI('tests/return/?test_id=' + test.test_id).then(response => {
                            const result = [];
                            for (const single of response) {
                                let score = -1;
                                const scores = JSON.parse(single.scores);
                                if (scores && scores.length > 0) {
                                    console.log("scores", scores);
                                    score = scores.reduce((prev, item) => Number.parseInt(prev) + Number.parseInt(item), 0);
                                }
                                single.score = score;
                                result.push(single);
                            }

                            const finished = this.state.finished;
                            finished[test.test_id] = result;
                            this.setState({finished: finished});
                        });

                        const questions = JSON.parse(test.test);
                        const max = questions.reduce((sum, question) => {
                            return Number.parseInt(sum) + Number.parseInt(this.resolveMaxPoints(question));
                        }, 0);

                        test['max_points'] = max;
                    }

                    if (!groups.includes(group_id)) {
                        groups.push(group_id);
                        const group = test.group;
                        group['tests'] = [];
                        grouped_tests.push(group);
                    }

                    for (const group of grouped_tests) {
                        if (group['id'] === group_id) {
                            group['tests'].push(test);
                            break;
                        }
                    }
                }

                const sorted_grouped = grouped_tests.sort((group1, group2) => group1.name.localeCompare(group2.name));

                this.setState({ grouped_tests: sorted_grouped, tests: response});
            });

        if (this.props.user && this.props.user.user_type === 'lecturer') {
            API.callAPI('tests/shared/')
                .then(response => {
                    this.setState({sharedTests: response});
                });
        }

        if (this.props.user && this.props.user.user_type !== 'lecturer') {
            API.callAPI('tests/score/')
                .then(response => {
                    const grouped_tests = JSON.parse(JSON.stringify(this.state.groups));
                    const groups = JSON.parse(JSON.stringify(this.state.groups));

                    for (const test of response) {
                        const group_id = test.group_id;

                        let score = -1;
                        const scores = JSON.parse(test.scores);
                        if (scores && scores.length > 0) {
                            score = scores.reduce((prev, item) => Number.parseInt(prev) + Number.parseInt(item), 0);
                        }
                        test['score'] = score;
                        test['scored'] = true;
                        const questions = JSON.parse(test.test);

                        if (!scores || (scores && scores.length === 0)) {
                            const answers = JSON.parse(test.answers);
                            const userAnwers = JSON.parse(test.userAnswers);
                            test['score'] = ScoreUtils.score(questions, answers, userAnwers);
                            test['scored'] = false;
                        }

                        const max = questions.reduce((sum, question) => {
                            return Number.parseInt(sum) + Number.parseInt(this.resolveMaxPoints(question));
                        }, 0);

                        test['max_points'] = max;

                        for (let i = 0; i < grouped_tests.length; i++) {
                            if (grouped_tests[i]['id'] === group_id) {
                                if (!grouped_tests[i]['tests']) {
                                    grouped_tests[i]['tests'] = [];
                                }
                                grouped_tests[i]['tests'].push(test);
                                break;
                            }
                        }
                    }

                    const sorted_grouped = grouped_tests
                        .filter(group => group.tests)
                        .sort((group1, group2) => group1.name.localeCompare(group2.name));

                    console.log(sorted_grouped);
                    this.setState({ grouped_test_answers: sorted_grouped });
                });
        }
    };

    resolveMaxPoints = (question) => {
        if (question['type'] === 'open') return question.points;
        if (question['type'] === 'closed') return 1;
        if (question['type'] === 'gap') return question.subtasks.length;
        return 0;
    };

    openView = (id) => {
        this.props.openView(id);
    };

    deleteTest = (id) => {
        this.setState({tests: undefined});

        const userIsSure = window.confirm("Na pewno?");
        if (userIsSure) {
            API.callAPI('tests/?id=' + id, 'DELETE')
                .then(() => {
                    this.loadTests();
                });
        }
    };

    mapGroup = (group) => {
        const tests = group.tests.map(this.mapTest);
        if (tests.length < 0) return;

        return (
            <div key={"group-item-" + group.id}>
                <div className="group-name">{group.name}</div>
                {tests}
            </div>
        );
    };

    mapTest = (test) => {
        const isLecturer = this.props.user.user_type === "lecturer";

        if (!isLecturer && !test.in_progress) {
            return;
        }

        const showMembers = this.state.showMembers[test.test_id] || false;

        const additionalButtons = <div className="test-actions">
            <span onClick={() => this.toggleMembers(test.test_id)}><i className={(showMembers ? "fas" : "far") + " fa-user"} /></span>
            <span onClick={() => this.openCopy(test.test_id)}><i className="far fa-copy" /></span>
            <span onClick={() => this.openShare(test.test_id)}><i className="far fa-share-square" /></span>
            {!test.in_progress ? <span onClick={() => this.startTest(test.test_id)}><i className="fas fa-play" /></span> : ''}
            {test.in_progress ? <span onClick={() => this.stopTest(test.test_id)}><i className="fas fa-stop" /></span> : ''}
            {!test.in_progress ? <span onClick={() => this.openView(test.test_id)}><i className="fas fa-edit" /></span> : '' }
            {!test.in_progress ? <span onClick={() => this.deleteTest(test.test_id)}><i className="far fa-trash-alt" /></span> : ''}
        </div>;

        let finished = [];
        let membersInProgress = [];

        if (isLecturer) {
            const finishedElement = this.state.finished[test.test_id];

            if (finishedElement) {
                finishedElement.sort((a, b) => a.user.last_name.localeCompare(b.user.last_name));

                finished = finishedElement.map(member =>
                        <div key={"finished-" + test.test_id + "-" + member.user.user_id} className="user-finished">
                            <span className="finished-name" onClick={() => {this.props.openCheck(test.test_id, member.user.user_id)}}><i
                                className="fas fa-user"/> {member.user.first_name} {member.user.last_name}</span>
                            <span className="test-score">{member.score >= 0 ? Number.parseFloat(100.0 * member.score / test.max_points).toFixed(2) + '%' :
                                <i className="fas fa-edit" />}</span>
                            <span className="test-return-time">{member.return_time}</span>
                        </div>);
            }

            const inProgress = this.state.inProgress[test.test_id];
            if (inProgress) {
                membersInProgress.sort((a, b) => a.user.last_name.localeCompare(b.user.last_name));

                membersInProgress = inProgress.map(member => <div key={"in-progress-" + test.test_id + "-" + member.user.user_id}
                                                  className="user-writing"><i
                        className="fas fa-user"/> {member.user.first_name} {member.user.last_name}</div>);
            }
        }

        return (
            <div key={"test-item-" + test.test_id}
                 className="test-item"
            >
                <div className="test-item-inner">
                    <span className="test-name" onClick={() => {
                        if (isLecturer) {
                            this.toggleMembers(test.test_id)
                        } else {
                            this.openView(test.test_id)
                        }
                    }}>{test.name}</span>
                    {isLecturer ?  additionalButtons : ''}
                </div>
                {isLecturer && showMembers ? finished : ''}
                {isLecturer && showMembers ? membersInProgress : ''}
            </div>
        );
    };

    mapScoredGroup = (group) => {
        const tests = group.tests.map(this.mapScoredTest);
        if (tests.length < 0) return;

        return (
            <div key={"group-item-" + group.id}>
                <div className="group-name">{group.name}</div>
                {tests}
            </div>
        );
    };

    mapScoredTest = (test) => {
        return (
            <div key={"test-item-" + test.test_id}
                 className="test-item"
            >
                <div className="test-item-inner">
                    <span className="test-name" onClick={() => {}}>{test.name}</span>
                    <span className="test-score">{Number.parseFloat(100.0 * test.score / test.max_points).toFixed(2) + '%'} {test.scored ? '' :
                        <i className="fas fa-edit" />}</span>
                    <span className="test-return-time">{test.return_time}</span>
                </div>
            </div>
        );
    };

    toggleMembers = (id) => {
        const showMembers = this.state.showMembers;
        const currentState = showMembers[id] || false;
        showMembers[id] = !currentState;
        this.setState({ showMemebers: showMembers });
    };

    startTest = (id) => {
        API.callAPI('tests/run/?id=' + id, 'POST')
            .then(response => {
                this.loadTests();
            });
    };


    stopTest = (id) => {
        API.callAPI('tests/run/?id=' + id, 'DELETE')
            .then(response => {
                this.loadTests();
            });
    };

    openCopy = (id) => {
        this.setState({ destinationGroup: this.state.groups[0] ? this.state.groups[0].id : 0, contextTestId: id, screen: "copy" })
    };

    openShare = (id) => {
        this.setState({ destinationUser: this.state.lecturers[0] ? this.state.lecturers[0].user_id : 0, contextTestId: id, screen: "share" })
    };

    closePopup = (id) => {
        this.setState({ screen: "list" })
    };

    copyTest = () => {
        const testId = this.state.contextTestId;
        const groupId = this.state.destinationGroup;
        const url = this.state.screen === "copy" ? 'tests/copy/' : 'tests/shared/';

        API.callAPI(url, 'POST', {
            test_id: testId,
            group_id: groupId
        }).then(() => {
            this.loadTests();
        });

        this.setState({ screen: "list" });
    };


    shareTest = () => {
        const testId = this.state.contextTestId;
        const userId = this.state.destinationUser;
        const url = 'tests/shared/';

        API.callAPI(url, 'PUT', {
            test_id: testId,
            user_id: userId
        }).then(() => {
            this.loadTests();
        });

        this.setState({ screen: "list" });
    };

    setDestinationGroup = (event) => {
        this.setState({ destinationGroup: event.target.value });
    };

    setDestinationUser = (event) => {
        this.setState({ destinationUser: event.target.value });
    };

    setName = (event) => {
        this.setState({ name: event.target.value });
    };

    setGroup = (event) => {
        this.setState({ group: event.target.value });
    };

    setDuration = (event) => {
        this.setState({ duration: event.target.value });
    };

    addTest = () => {
        API.callAPI('tests/', 'POST', {
           "group_id": this.state.group,
           "name": this.state.name,
           "time": this.state.duration
        }).then(response => {
            if (!response['error']) {
                this.openView(response.test_id);
            } else {
                this.loadTests();
            }
        });
    };

    openAccept = (id) => {
        this.setState({ destinationGroup: this.state.groups[0] ? this.state.groups[0].id : 0, contextTestId: id, screen: "accept" });
    };

    rejectTest = (id) => {
        API.callAPI('tests/shared/?id=' + id, 'DELETE').then(response => {
            this.loadTests();
        });
    };

    render() {
        const isLecturer = this.props.user.user_type === "lecturer";

        const type = isLecturer ? '(lektor)' : '';

        const tests = this.state.grouped_tests ?
            this.state.grouped_tests.map(this.mapGroup)
            : <div className="loader-wrapper">
                <div className="loader"/>
            </div>;

        const addTest =
            <div className="new-test-wrapper">
                <input type="text" value={this.state.name} onChange={this.setName} className="new-test-name" placeholder="Nazwa" />
                <select value={this.state.group} onChange={this.setGroup}>
                    {this.state.groups.map(group => <option value={group.id} key={"group-item-" + group.id}>{group.name}</option>)}
                </select>
                <input className="new-test-duration" type="number" min="1" value={this.state.duration} onChange={this.setDuration} /> min
                <button className="btn-square" onClick={this.addTest}><i className="fas fa-plus" /></button>
            </div>;

        let testName = '';
        if (this.state.screen !== "list") {
            for (const test of this.state.tests) {
                if (test.test_id === this.state.contextTestId) {
                    testName = test.name;
                }
            }

            for (const test of this.state.sharedTests) {
                if (test.test_id === this.state.contextTestId) {
                    testName = test.name;
                }
            }
        }

        const copyTest =
            <div className="popup-wrapper copy-wrapper">
                <div className="popup copy">
                    <h3 className="popup-title">{testName}</h3>
                    <div className="section">Skopiuj do:</div>
                    <select value={this.state.destinationGroup} onChange={this.setDestinationGroup}>
                        {this.state.groups.map(group => <option value={group.id} key={"group-item-" + group.id}>{group.name}</option>)}
                    </select>
                    <div className="buttons">
                        <button className="btn-square" onClick={this.closePopup}>Anuluj</button>
                        <button className="btn-square btn-square-primary" onClick={this.copyTest}>Kopiuj</button>
                    </div>
                </div>
            </div>;

        const shareTest =
            <div className="popup-wrapper copy-wrapper">
                <div className="popup copy">
                    <h3 className="popup-title">{testName}</h3>
                    <div className="section">Udostępnij dla:</div>
                    <select value={this.state.destinationUser} onChange={this.setDestinationUser}>
                        {this.state.lecturers.map(lecturer => <option value={lecturer.user_id} key={"lecturer-item-" + lecturer.user_id}>{lecturer.last_name} {lecturer.first_name}</option>)}
                    </select>
                    <div className="buttons">
                        <button className="btn-square" onClick={this.closePopup}>Anuluj</button>
                        <button className="btn-square btn-square-primary" onClick={this.shareTest}>Udostępnij</button>
                    </div>
                </div>
            </div>;

        const hasSharedTests = this.state.sharedTests && this.state.sharedTests.length > 0;
        let sharedTests = '';

        if (hasSharedTests) {
            const shared = this.state.sharedTests.map(test =>
                <div key={"test-item-" + test.test_id}
                     className="test-item"
                >
                    <div className="test-item-inner">
                        <span className="test-name">{test.name} <span className="test-from">od {test.creator.last_name} {test.creator.first_name}</span></span>
                        <span className="test-actions">
                            <span onClick={() => this.openAccept(test.test_id)}><i className="fas fa-check" /></span>
                            <span onClick={() => this.rejectTest(test.test_id)}><i className="fas fa-times" /></span>
                        </span>
                    </div>
                </div>
            );

            sharedTests = <div className="shared-tests">
                <h2 className="section-title">Udostępnione</h2>
                {shared}
            </div>
        }

        let scoredTests = '';
        if (this.state.grouped_test_answers && this.state.grouped_test_answers.length > 0) {
            scoredTests =
                <div className="scored-tests">
                    <h2 className="section-title">Wyniki testów</h2>
                    {this.state.grouped_test_answers.map(this.mapScoredGroup)}
                </div>
        }

        return (
            <div className="test-list">
                <div className="toolbar">
                    <div className="toolbar-content">
                        <div>Zalogowany jako <span
                            className="name">{this.props.user.first_name} {this.props.user.last_name} {type}</span>
                        </div>
                        <div>
                            <button className="btn-square" onClick={() => {
                                API.callAPI('authorize/', 'DELETE')
                            }}>Wyloguj
                            </button>
                        </div>
                    </div>
                </div>
                <div className="tests-container">
                    {this.state.screen === "copy" || this.state.screen === "accept" ? copyTest : ''}
                    {this.state.screen === "share" ? shareTest : ''}
                    {sharedTests}
                    <h2 className="section-title">Testy</h2>
                    {tests.length === 0 ? <div>Brak testów</div> : tests}
                    {isLecturer ? addTest : ''}
                    {scoredTests}
                </div>
            </div>
        );
    }
}

export default TestList;